import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import assign from 'lodash/assign'
import qs from 'querystring'
import moment from 'moment'

import { ResourceModel } from '@modules/resource/resource.module'

import AsyncDataExportOverlay from '@components/DataExportOverlay/AsyncDataExportOverlay'
import RemoteDataTable from '@components/RemoteDataTable/RemoteDataTable'
import PageHeaderSticky from '@components/PageHeaderSticky/PageHeaderSticky'

import './Archive.scss'

export default class Archive extends React.Component {

	static propTypes = {
		title: PropTypes.string.isRequired,
		Model: PropTypes.instanceOf(ResourceModel),
		showNewLink: PropTypes.bool,
	};

	static defaultProps = {
		showNewLink: true,
	};

	// Render

	render() {
		var { 
			title, 
			Model,
			showNewLink,
		} = this.props;

		var {
			tableConfig,
			...props,
		} = this.props;
		// TODO: abstract some of this to Layout component
		return (
			<main className="Archive page-content">

				<PageHeaderSticky title={title}>
						{
							showNewLink &&
							<Link to={`/${Model.resourceKey}/new`}><button type="button" className="btn btn-primary">new</button></Link>
						}
						{ Model.mapDataToCSVPlural && 
							this.renderDataExportButton() 
						}
				</PageHeaderSticky>

				<RemoteDataTable {...props} {...tableConfig} />

			</main>
		);
	}

	renderDataExportButton() {
		const {
			title,
			filename, 
			currentQuery,
			Model,
		} = this.props;

		return <AsyncDataExportOverlay 
			title={`Export ${title}`}
			mapDataToCSV={Model.mapDataToCSVPlural.bind(Model)}
			Model={Model}
			filename={filename ? filename : `h1export-${Model.resourceKey}s-${moment().format('YYYYMMDD')}.csv`} 
			fetchData={async() => {

				const query = assign({}, currentQuery, {
					page: 1,
					limit: 999999, // TODO: make limit:0 work with mongoose.aggregatePaginate
				});
				const queryString = qs.stringify(query);

				const res = await fetch(`api/${Model.resourceKey}?${queryString}`);
				
				const data = await res.json();

				return data.docs;

			}}
		/>
	}

}



// WEBPACK FOOTER //
// ./src/components/Archive/Archive.jsx